import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    tabsWrapper: {
        borderBottom: "none",
        borderColor: "divider",
        position: "absolute",
    },
    tab: {
        margin: '0 16px 0 16px',
        width: "15rem",
        background: "#5B5D6E",
        borderRadius: "6px 6px 0 0",
        fontSize: "15px",
        fontWeight: "700",
        textTransform: "none",
    },
    tabsHeaderContainer: {
        bottom: '38.5%',
        left: ({ isNavbarOpen }) => isNavbarOpen ? '21%' : '12%',
        transition: 'left 0.4s',
        position: 'absolute'
    },
    settingsPanel: {
        minHeight: '700px',
        backgroundColor: ({ theme }) => theme.palette.themeColor,
    }
});
